import { combineReducers } from "redux";
import { initialReducer } from './initialReducer.js'
import { authReducer } from "./authReducer"
import { userReducer } from "./userReducer.js";

const rootReducer = combineReducers({ initialReducer, authReducer, userReducer });
export default rootReducer;


